import React from 'react'

const Delete = () => (
  <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg">
    <path d="M6 19l2 2h8l2-2V7H6v12zM8 9h8v10H8V9zm8-5l-1-1h-5L9 4H5v2h14V4h-3z" />
  </svg>
)

export default Delete
